import React, { useState, useCallback, useEffect } from 'react';
import {
  Box,
  IconButton,
  useTheme,
  InputAdornment,
  TextField,
  Button,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from '@material-ui/styles';
import { useIntl } from 'umi';
import { useDispatch, useSelector } from 'dva';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import CouponModalStyled from './CouponModalStyled';
import DataTableNativeML from '@/components/DataTableNativeML';

export default (props) => {
  const theme = useTheme();
  const useStyles = makeStyles(() => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      position: 'absolute',
      width: 900,
      height: 800,
      padding: '24px 32px',
      background: '#fff',
      boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
    },
  }));
  const loadingEffect = useSelector((state) => state.loading);
  const couponLoading = loadingEffect.effects['cpList/getCpList'];
  const classes = useStyles();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;

  //规则名称
  const [ruleName, setRuleName] = useState();
  //后端查询字段
  const [name, setName] = useState();

  const { control, setValue } = useForm({});

  const dispatch = useDispatch();
  const { couponList } = useSelector((state) => state.voucherEdit) || [];
  const { selectedIds: defaultIdList, onConfirm, open, onClose, title } = props;
  const onHandleClickSearchStores = () => {
    setName(ruleName);
    setPageData({ ...pageData, pageNum: 1 });
  };

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  // 存储选中的数据
  const [selectedIdList, setSelectedIdList] = useState(defaultIdList);

  const fetchCouponPage = useCallback(() => {
    dispatch({
      type: 'cpList/getCpList',
      payload: {
        values: {
          title: name,
          status: 'NOT_COMPLETE',
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
        },
      },
    });
  }, [dispatch, pageData, name]);

  useEffect(() => {
    fetchCouponPage();
  }, [fetchCouponPage]);
  const { data: cpList, total } =
    useSelector((state) => state.cpList?.cpList) || {};
  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };
  const handleClose = () => {
    onClose();
  };

  const onSubmit = () => {
    const id = selectedIdList?.[0];
    if (couponList?.find((item) => item.id === id)) {
      return window.message.toast({
        type: 'error',
        message: '同一个券ID只能选一次，不可选择重复的优惠券',
      });
    }
    if (id) {
      const selectedCouponItem = cpList.find((item) => item.id === id);
      onConfirm(selectedCouponItem);
    }

    onClose();
  };

  const columns = [
    {
      type: 'checkbox',
      align: 'right',
      width: 80,
      onChange: (newSelected) => {
        setSelectedIdList(newSelected);
      },
    },
    {
      title: '优惠券名称',
      align: 'center',
      id: 'title',
      key: 'title',
    },
    {
      title: '适用商品',
      id: 'isAllGoods',
      width: 145,
      align: 'center',
      key: 'isAllGoods',
      render: ({ isAllGoods }) => {
        switch (isAllGoods) {
          case 0:
            return '指定适用商品';
          case 1:
            return '所有商品';
          case 2:
            return '不适用商品';
          default:
            return '';
        }
      },
    },
    {
      title: '优惠内容',
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      width: 145,
    },
    {
      title: '领取人限制',
      align: 'center',
      id: 'memberLimit',
      key: 'memberLimit',
      width: 135,
      render: ({ memberLimit }) => {
        return <div>{memberLimit ? '不限' : '会员'}</div>;
      },
    },
    {
      title: '限领次数',
      align: 'center',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 125,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{isLimitMaxCoupons ? '限制' : '不限'}</div>;
      },
    },
    {
      title: '剩余库存',
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 145,
    },
  ];

  return (
    <CouponModalStyled
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      theme={theme}
      className={classes.modal}
    >
      <Box className={classes.paper}>
        <Box className="first_line">
          <div className="title">{title || '选择优惠券'}</div>
          <div className="close">
            <SvgIconML
              size={20}
              name={'modalClose'}
              onClick={props.onClose}
              fill="#212121"
            />
          </div>
        </Box>
        <Box mb={2} className="search_wrapper" mt={2}>
          <Controller
            render={(rp) => (
              <TextField
                value={ruleName || rp.value}
                name="name"
                onChange={(e) => {
                  setRuleName(e.target.value);
                  setValue('name', e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={onHandleClickSearchStores}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        className="clear-btn"
                        onClick={() => {
                          setValue('name', '');
                          setRuleName();
                          setName();
                          setPageData({ ...pageData, pageNum: 1 });
                        }}
                        edge="end"
                      >
                        {ruleName && <ClearIcon className="clear-icon" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="优惠券名称"
                placeholder="请输入优惠券名称"
                defaultValue={''}
              />
            )}
            name="name"
            control={control}
            id="basic"
            variant="standard"
            className="rule_name"
            label="优惠券名称"
            defaultValue={''}
          />
        </Box>
        <Box className="table">
          <DataTableNativeML
            singleSelect
            loading={couponLoading}
            columns={columns}
            chooseIds={selectedIdList}
            changePage={changePage}
            page={pageData}
            data={cpList}
            columnKey="id"
            total={total}
            paging={true}
            devicesMinWidth="auto"
            control={control}
          ></DataTableNativeML>
        </Box>
        <div className="modal-btn-wrap">
          <Button onClick={handleClose} variant="contained" color="secondary">
            {formatMessage({ id: 'comm.action.btn.08' })}
          </Button>
          <Button
            variant="contained"
            className="btnSubmit button"
            onClick={onSubmit}
          >
            {formatMessage({ id: 'comm.action.btn.07' })}
          </Button>
        </div>
      </Box>
    </CouponModalStyled>
  );
};
